<i18n>
{
  "fr": {
    "add-luggages": "Ajouter des bagages",
    "no-options": "Pas d'options disponibles",
    "type-of-flight": {
      "outward": "Vol aller",
      "return": "Vol retour",
      "common": "Vols aller et retour"
    }
  },
  "en": {
    "add-luggages": "Add luggage",
    "no-options": "No options available",
    "type-of-flight": {
      "outward": "Outward flight",
      "return": "Return flight",
      "common": "Outward and return flights"
    }
  }
}
</i18n>

<template>
  <div>
    <span class="caption">{{ $t(`type-of-flight["${typeOfFlight}"]`) }}</span>
    <v-select
      v-model="inputOptionsParam.selected_value"
      :items="removeFreeOptionsFromDisplay(inputOptionsParam.options)"
      :disabled="!removeFreeOptionsFromDisplay(inputOptionsParam.options).length"
      :placeholder="!removeFreeOptionsFromDisplay(inputOptionsParam.options).length ? $t('no-options') : $t('add-luggages')"
      :menu-props="{'offset-y': true, 'auto': true}"
      item-value="option"
      class="mt-2"
      clearable
      dense
      height="42px"
      outlined
      return-object
    >
      <template #item="{ item }">
        <div class="v-list-item__title mb-2">
          <v-row>
            <v-col
              cols="5"
              class="pl-5 pb-1"
            >
              {{ removePluralAndTranslate(item.quantity) }}
            </v-col>
            <v-col class="pl-0 pb-1 text-center bigger-letter-space">
              {{ formatPriceWithNarrowSymbol(item.amount,item.currency) }}
            </v-col>
          </v-row>
          <span class="luggages-weight font-italic pl-2">
            {{ formatLuggageWeightDetails(item.weight) }}
          </span>
        </div>
      </template>
      <template #selection="{ item }">
        <div class="v-list-item__title mb-1">
          <v-row>
            <v-col
              cols="5"
              class="pl-5 pb-1"
            >
              {{ removePluralAndTranslate(item.quantity) }}
            </v-col>
            <v-col class="pl-0 pb-1 text-center bigger-letter-space">
              {{ formatPriceWithNarrowSymbol(item.amount, item.currency ) }}
            </v-col>
          </v-row>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import luggageOptionsMixin from '@/mixins/luggageOptions'
import globalMixin from '@/mixins/global'

export default {
  name: 'SelectLuggageOption',
  mixins: [luggageOptionsMixin, globalMixin],
  props: {
    typeOfFlight: {
      type: String,
      required: true
    },
    optionsParam: {
      type: Object,
      default: null
    }
  },
  computed: {
    inputOptionsParam: {
      get () {
        return this.optionsParam
      },
      set (value) {
        return this.$emit('input', value)
      }
    }
  },
  methods: {
    removeFreeOptionsFromDisplay (items) {
      return items.filter(item => item.amount > 0)
    }
  }
}
</script>

<style scoped>

.luggages-weight {
  font-size: 11px;
}

.bigger-letter-space {
  letter-spacing: 1px;
}

/* Do not remove  /!\ (fixed value for selects) */
.v-text-field {
  width: 280px;
}

</style>
